import { ref, reactive } from 'vue'
import apiClient from '../api/axios.js'

// 舵机可用性校验：对舵机 0 ~ N 同时下发绝对角度 A/B，循环往返后归零。
export function useServoDebug({ selectedEnv, deviceId, showSnackbar }) {
  const servoDebugDialog = ref(false)
  const servoDebugRunning = ref(false)
  const EXECUTE_INTERVAL = 500

  const servoDebugForm = reactive({
    maxServoId: 0,
    interval: 1000,
    loopCount: 1,
    angleA: 0,
    angleB: 0
  })

  let stopped = false

  function openServoDebugDialog() {
    servoDebugDialog.value = true
  }

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

  function sendAbsoluteAngle(node, angle) {
    return apiClient.post(
      selectedEnv.value.manager_url + '/xiaozhi/device/send-message',
      {
        device_id: deviceId.value,
        params: {
          name: 'self.servo.debug',
          arguments: { operate: 1, node, data: angle }
        }
      },
      { headers: { 'Content-Type': 'application/json' } }
    ).catch(() => {})
  }

  function sendAngleToAllServos(nodes, angle) {
    return Promise.all(nodes.map(node => sendAbsoluteAngle(node, angle)))
  }

  async function runAbsoluteAngleTest() {
    if (!selectedEnv.value.manager_url || !deviceId.value) {
      showSnackbar('请先选择环境和设备')
      return
    }
    if (servoDebugRunning.value) return

    const maxId = Math.max(0, Number(servoDebugForm.maxServoId) || 0)
    const nodes = Array.from({ length: maxId + 1 }, (_, idx) => idx)
    const angleA = Number(servoDebugForm.angleA)
    const angleB = Number(servoDebugForm.angleB)
    const loopCount = Math.max(1, Number(servoDebugForm.loopCount) || 1)
    const interval = Math.max(0, Number(servoDebugForm.interval) || 0)

    servoDebugRunning.value = true
    stopped = false

    try {
      for (let i = 0; i < loopCount; i++) {
        if (stopped) break
        showSnackbar(`舵机 0~${maxId} 可用性校验：第 ${i + 1}/${loopCount} 次`)

        await sendAngleToAllServos(nodes, angleA)
        await sleep(EXECUTE_INTERVAL)
        if (stopped) break

        await sendAngleToAllServos(nodes, angleB)
        await sleep(EXECUTE_INTERVAL)
        if (stopped) break

        if (i < loopCount - 1 && interval > 0) {
          await sleep(interval)
        }
      }

      await sendAngleToAllServos(nodes, 0)
      showSnackbar(stopped ? '可用性校验已停止，舵机已归零' : '舵机可用性校验完成，舵机已归零')
    } finally {
      servoDebugRunning.value = false
    }
  }

  function stopAbsoluteAngleTest() {
    stopped = true
  }

  return {
    servoDebugDialog,
    servoDebugRunning,
    servoDebugForm,
    openServoDebugDialog,
    runAbsoluteAngleTest,
    stopAbsoluteAngleTest
  }
}
